import { useSelector } from 'react-redux';

import { createSelector } from '@reduxjs/toolkit';

import { ResourceString } from '@/reducers/common/commonTypes';
import { selectResources } from '@/reducers/common/selectors';

const selectData = createSelector(selectResources, (resources) => ({
  googleBtn: resources['SignIn.googleButton'] ?? 'Sign in with Google',
  facebookBtn: resources['SignIn.facebookButton'] ?? 'Sign in with Facebook',
  appleBtn: 'Sign in with Apple',
  email: resources['SignInForm.email'] ?? 'Email',
  pswd: resources['SignInForm.password'] ?? 'Password',
  keeplogintext: resources['SignInForm.keeplogintext'] ?? 'Keep me logged in',
  signinButton: resources['SignInForm.signInButton'] ?? 'Sign in',
  serverErrorMsg:
    resources['SignIn.incorrectPassword'] ??
    "Looks like you've entered an incorrect email address and/or password (we get it, there are too many to remember these days). Please try again.",
  firstNameHeading: resources['SignUpForm.firstname'] ?? 'First name',
  lastnameHeading: resources['SignUpForm.lastname'] ?? 'Last name',
  emailHeading: resources['SignUpForm.email'] ?? 'Email',
  dobHeading: resources['SignUpForm.dob'] ?? 'Date of birth',
  signupContinue: resources['SignUpSocialMediaForm.submit'] ?? 'Continue',
  invalidTLDs: resources['SailorForm.InvalidTLD'] ?? 'con,von,ron,vom,comp,cdom,gom,cpm,comm,cokm',
}));

const useResourcesData = () => useSelector(selectData) as ResourceString;

export default useResourcesData;
